import React from 'react'
import "./Green_btn.css"
import { Button } from 'react-bootstrap'

function Green_btn({btn_text,onClick }) {
  return (
  <>
    <section className="Green_btn_holder">
        <Button className="Green_btn" type="button" onClick={onClick}>
          {btn_text}
        </Button>
      </section>
  </>
  )
}

export default Green_btn